import { initialProps } from '@utils/initial'
import Error from './404'
import Head from 'next/head'
import { HomeWellnessLayout, Hero, Experts, WhyJoin, WhyJoinList, JoinFree, AppleFooter, ErrorBoundary } from '@components/Block'
import { useEffect } from 'react'
import { LcwLayout, IndexHeader, WhatYouWillLearn, ScientificBreakthrough, SuccessStoryBecky,
    WhyCarbs, RevealMostDiets, HelpfulResources, SuccessStoryAaron, TakeAPeek7BS, About, 
    DiscoverHow, SevenWaysHeader,SevenWaysBrain,MemoryLoss,TakeAPeek7Ways, 
    AboutMe,FreeReport,LearnHowTo,ConfusingFrustrating,DavidColby,TvcWorkbook,
    IndexHeaderWYD,PhysiciansDiseasedOriented,WhoDoYouTurn,LessSixPercent,
    WantToLearn,TakeAPeekWYD,FreeReportWYD,VitalityForLife,VflHeader,EasyToRead,
    Discover, IndexHeaderDiscover, WhatToShowDiscover, HelpMe   
} from '@components/Block'

export async function getServerSideProps({req, res, query}) {

    return {
        props: await initialProps(req, res, query)
    }
}

const WellnessCenter = (props) => { 

   //console.log('props:',props);

   if (typeof props.err !== "undefined")
       return <Error statusCode={props.err.code} />

    const site = props.site
    const name = site ? site.name : '';

    const title = "Join Our Wellness Center - " + name
    const description = "Create a free account in my wellness center and discover how to have long-lasting vitality and well-being with Shaklee products."

    useEffect(() => {

        if (props.auth.isAuthenticated) {
            //window.location.href = '/home'
        }

        if(props.reload) {
            window.location.reload()
        }
      
    }, [])

    const code = props && props.site ? props.site.site.code : '';

    if(code == "7BS"){

        return (
            <LcwLayout global={props}
                ogurl="/7big-secrets-to-180" 
                ogsiteName="The 7 Big Secrets to Losing Weight"
                ogsiteDesc="Special report reveals how some of Hollywood's biggest stars get in shape and look their best within weeks." 
                ogImg="../images/7bs/img-7-big-secrets-to-weight-loss-share01.jpg"
                ogIcon="../images/7bs/img-favicon-7bs01.ico"
            >
                <IndexHeader global={props}/>
                <WhatYouWillLearn/>
                <ScientificBreakthrough/>
                <SuccessStoryBecky/>
                <WhyCarbs/>
                <RevealMostDiets/>
                <HelpfulResources/>
                <SuccessStoryAaron/>
                <TakeAPeek7BS/>
                <About global={props} />
                <DiscoverHow global={props}/>
            </LcwLayout>
        )

    }else if(code == "TVC"){

        return (
            <div className="page__Tvc">
                <LcwLayout global={props}
                ogurl="/vitamin-checklist" 
                ogsiteName="The Vitamin Checklist"
                ogsiteDesc="Learn the right questions to ask when buying your next vitamin supplement." 
                ogImg="../images/tvc/img-tvc-share01.jpg"
                ogIcon="../images/tvc/img-favicon-tvc02.png"
                >
                    <LearnHowTo global={props}/>
                    <ConfusingFrustrating global={props}/>
                    <DavidColby/>
                    <TvcWorkbook global={props}/>
                </LcwLayout>
                <style jsx global>{`
                    .bg-orange{
                    background:#FC8D58;
                    }
                    .text-orange{
                    color:#FC8D58;
                    }
                    .btn:hover,
                    .btn:focus,
                    .btn:active{
                    text-decoration: none;
                    box-shadow: none;
                    }
                    @media(max-width: 991px){
                        .text-btn-center{
                            text-align:center!important;
                        }
                    }
                    @media(max-width: 480px){
                        .btn{
                            padding:0px;
                            font-size:1.5rem;
                        }
                        .media{
                            display:block;
                        }
                        .media img{
                            display: block;
                            margin-left: auto!important;
                            margin-right: auto!important;
                        }
                    }
                    `}
                </style>
            </div>
        )

    }else if(code == "7WAYS"){

        return (
            <LcwLayout global={props}
                ogurl="/7ways-to-improve-memory" 
                ogsiteName="7 Ways to Improve Your Memory, Focus and Reduce Mental Decline"
                ogsiteDesc="Have you ever forgotten who you were calling after you dialed the phone? Memory loss is a frightening thing. If you’re worried about brain health, you’re not alone. Click to Download my Special Report." 
                ogImg="../images/7ways/img-7ways-share01.jpg"
                ogIcon="../images/7ways/img-favicon01.jpg"
            >
                
                <SevenWaysHeader global={props}/>
                <SevenWaysBrain/>
                <MemoryLoss global={props}/>
                <TakeAPeek7Ways/>
                <AboutMe global={props} />
                <FreeReport global={props}/>
            </LcwLayout>
        )
    }else if(code == "WYD"){

        return (
            <LcwLayout global={props}
                ogurl="/what-your-doctor-wasnt-taught" 
                ogsiteName="What your Doctor wasn&#039;t Taught in Med School"
                ogsiteDesc="Less than 6% of Doctors get formal training in nutrition. Don't rely on them to get the knowledge you need to build health. Click here to download this report today." 
                ogImg="../images/wyd/img-doctor-webinar-share01.jpg"
                ogIcon="../images/wyd/img-favicon-wyd01.png"
            >            
                <IndexHeaderWYD global={props}/>
                <PhysiciansDiseasedOriented/>
                <WhoDoYouTurn/>
                <LessSixPercent/>
                <WantToLearn/>
                <TakeAPeekWYD/>
                <FreeReportWYD global={props}/>
            </LcwLayout>
        )

    }else if(code == "VFL"){

        return (
            <div className="page__vfl">
                <VitalityForLife global={props}>
                    <Head>
                    <title>Vitality for Life</title>
                    <meta name="viewport" content="initial-scale=1.0, width=device-width" />
                    </Head>
                    <VflHeader/>
                    <EasyToRead/>
                </VitalityForLife>
            </div>
        )
    }else if(code == "EW"){
        return (
        <Discover global={props}>
                <Head><title>Explore Wellness</title></Head>
                <IndexHeaderDiscover site={props} />
                <WhatToShowDiscover/>
                <HelpMe site={props.site}/>
            </Discover>
        )
    }else{

        return (
            <HomeWellnessLayout global={props}>
                <Head>
                    <title>{title}</title>
                    <meta property="og:title" content={title} />
                    <meta name="description" content={description} />
                    <meta name="keywords" content={"Your Wellness Project, " + name} />
                    <meta property="og:title" content={title} />
                    <meta property="og:description" content={description} />
                </Head>
                <Hero site={props} metadata={props.metadata}/>
                
                <Experts site={props}/>
                <WhyJoin/>
                <WhyJoinList/> 
                <JoinFree/>
                <AppleFooter site={props}/>
                
            </HomeWellnessLayout>
        )
    }
}

export default WellnessCenter